// @core/api/endpoints/analytics/update_report_schedule.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ReportScheduleResponse,
  UpdateReportScheduleRequest,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Update report schedule
 * Updates a report schedule's cron expression, recipients, or active status.
 */
export async function UpdateReportSchedule(
  schedule_id: string,
  data: UpdateReportScheduleRequest,
  options?: RequestOptions
): Promise<ReportScheduleResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/analytics/report-schedules/:schedule_id`;
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.put<ReportScheduleResponse>(requestPath, data, requestOptions);
}
